import { render, staticRenderFns } from "@/components/Layout/Menu/Administracion/Administracion_destinos/Administracion_destinos.html?vue&type=template&id=7d58d2c0&scoped=true&"
import script from "@/components/Layout/Menu/Administracion/Administracion_destinos/Administracion_destinos.js?vue&type=script&lang=js&"
export * from "@/components/Layout/Menu/Administracion/Administracion_destinos/Administracion_destinos.js?vue&type=script&lang=js&"
import style0 from "@/components/Layout/Menu/Administracion/Administracion_destinos/Administracion_destinos.css?vue&type=style&index=0&id=7d58d2c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d58d2c0",
  null
  
)

export default component.exports